import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );

( function( app ) {
  const COMPONENT = {
    className: 'archway-hero',
    selector: function() {
      return '.' + this.className;
    },
    init: function() {
      const updateTopOffset = () => {
        let topOffset = $( 'header' ).height() || 0;
        if ( $( 'body.logged-in' ).length > 0 ) {
          topOffset += 32;
        }
        return topOffset;
      };

      const tl = gsap.timeline( {
        scrollTrigger: {
          trigger: '.archway-hero',
          start: () => `top top+=${updateTopOffset()}px`,
          scrub: 1,
          pin: true,
          pinSpacing: true,
          anticipatePin: 2,
          onUpdate: () => {
            const pinnedElement = document.querySelector( '.archway-hero' );
            if ( pinnedElement ) {
              pinnedElement.style.bottom = '0px';
            }
          },
        },
      } );

      tl.to( '.archway-hero__arch', {
        scale: 3,
        duration: 3,
      }, 0 );

      tl.to( '.archway-hero__bg', {
        opacity: 0,
        duration: 1,
      }, '+=0.1' );

      tl.fromTo(
          '.archway-hero__intro',
          {
            scale: 0.80,
            yPercent: 50,
          },
          {
            scale: 1,
            yPercent: 0,
            duration: 2,
            ease: 'power2.out',
          },
          0,
      );

      tl.to( '.archway-hero__secondary', {
        opacity: 1,
        y: '-20%',
        duration: 1,
      }, '+=0.2' );

      tl.to( '.archway-hero__services', {
        opacity: 1,
        y: '-10%',
        duration: 1,
      }, '+=0.3' );

      window.addEventListener( 'resize', () => {
        ScrollTrigger.refresh( true );
      } );

      const observer = new MutationObserver( () => {
        ScrollTrigger.refresh( true );
      } );

      observer.observe( document.querySelector( 'header' ), {attributes: true, childList: true, subtree: true} );
    },
    finalize: function() {},
  };

  app.registerComponent( 'archway-hero', COMPONENT );
} )( app );
